import React, { useEffect, useMemo } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "_common/hooks";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import { useMediaQuery } from "_common/component/MediaQueryProvider";
import MobileHistory from "./MobileHistory";
import DesktopHistory from "./DesktopHistory";

const ListHistoryBalance = observer(() => {
  const navigate = useNavigate();
  const { isMobile } = useMediaQuery();
  if (isMobile) return <MobileHistory />;

  return <DesktopHistory />;
});

export default ListHistoryBalance;
